/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Api
 * Baby Market API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveReservation200,
  ArchiveWithdrawnOffer200,
  CancelPurchaseRequestBody,
  CloseConversationResponse,
  Conversation,
  CreateListing,
  CreateMessage,
  CreateRating,
  DirectReservation,
  ErrorEnvelope,
  ErrorResponse,
  GetConversationsParams,
  GetListingsParams,
  GetMessagesParams,
  GetWishMessagesParams,
  GuestSessionRequest,
  HealthStatus,
  Listing,
  ListingsPage,
  Message,
  PublicUser,
  PurchaseRequestResult,
  RatingItem,
  RequestToBuyBody,
  SendWishMessage,
  User,
  WishMessage
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthStatus>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<HealthStatus>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<HealthStatus>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetListingsUrl = (params?: GetListingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/listings?${stringifiedParams}` : `/api/listings`
}

/**
 * @summary Get all listings
 */
export const getListings = async (params?: GetListingsParams, options?: RequestInit): Promise<ListingsPage> => {

  return customFetch<ListingsPage>(getGetListingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetListingsQueryKey = (params?: GetListingsParams,) => {
    return [
    `/api/listings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListingsQueryOptions = <TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(params?: GetListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListings>>> = ({ signal }) => getListings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getListings>>>
export type GetListingsQueryError = ErrorType<unknown>


/**
 * @summary Get all listings
 */

export function useGetListings<TData = Awaited<ReturnType<typeof getListings>>, TError = ErrorType<unknown>>(
 params?: GetListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateListingUrl = () => {




  return `/api/listings`
}

/**
 * @summary Create a new listing
 */
export const createListing = async (createListing: CreateListing, options?: RequestInit): Promise<Listing> => {

  return customFetch<Listing>(getCreateListingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createListing)
  }
);}





export const getCreateListingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListing>>, TError,{data: BodyType<CreateListing>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createListing>>, TError,{data: BodyType<CreateListing>}, TContext> => {

const mutationKey = ['createListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createListing>>, {data: BodyType<CreateListing>}> = (props) => {
          const {data} = props ?? {};

          return  createListing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateListingMutationResult = NonNullable<Awaited<ReturnType<typeof createListing>>>
    export type CreateListingMutationBody = BodyType<CreateListing>
    export type CreateListingMutationError = ErrorType<unknown>

    /**
 * @summary Create a new listing
 */
export const useCreateListing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createListing>>, TError,{data: BodyType<CreateListing>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createListing>>,
        TError,
        {data: BodyType<CreateListing>},
        TContext
      > => {
      return useMutation(getCreateListingMutationOptions(options));
    }

export const getGetListingUrl = (id: number,) => {




  return `/api/listings/${id}`
}

/**
 * @summary Get a listing by ID
 */
export const getListing = async (id: number, options?: RequestInit): Promise<Listing> => {

  return customFetch<Listing>(getGetListingUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetListingQueryKey = (id: number,) => {
    return [
    `/api/listings/${id}`
    ] as const;
    }


export const getGetListingQueryOptions = <TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListingQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListing>>> = ({ signal }) => getListing(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListingQueryResult = NonNullable<Awaited<ReturnType<typeof getListing>>>
export type GetListingQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a listing by ID
 */

export function useGetListing<TData = Awaited<ReturnType<typeof getListing>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getListing>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListingQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateListingUrl = (id: number,) => {




  return `/api/listings/${id}`
}

/**
 * @summary Update a listing
 */
export const updateListing = async (id: number,
    createListing: CreateListing, options?: RequestInit): Promise<Listing> => {

  return customFetch<Listing>(getUpdateListingUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createListing)
  }
);}





export const getUpdateListingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListing>>, TError,{id: number;data: BodyType<CreateListing>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateListing>>, TError,{id: number;data: BodyType<CreateListing>}, TContext> => {

const mutationKey = ['updateListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateListing>>, {id: number;data: BodyType<CreateListing>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateListing(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateListingMutationResult = NonNullable<Awaited<ReturnType<typeof updateListing>>>
    export type UpdateListingMutationBody = BodyType<CreateListing>
    export type UpdateListingMutationError = ErrorType<unknown>

    /**
 * @summary Update a listing
 */
export const useUpdateListing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateListing>>, TError,{id: number;data: BodyType<CreateListing>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateListing>>,
        TError,
        {id: number;data: BodyType<CreateListing>},
        TContext
      > => {
      return useMutation(getUpdateListingMutationOptions(options));
    }

export const getDeleteListingUrl = (id: number,) => {




  return `/api/listings/${id}`
}

/**
 * @summary Delete a listing
 */
export const deleteListing = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteListingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteListingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteListing>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteListing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteListing>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteListing(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteListing>>>

    export type DeleteListingMutationError = ErrorType<unknown>

    /**
 * @summary Delete a listing
 */
export const useDeleteListing = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteListing>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteListing>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteListingMutationOptions(options));
    }

export const getMarkListingSoldUrl = (id: number,) => {




  return `/api/listings/${id}/mark-sold`
}

/**
 * @summary Mark a listing as sold (seller confirms sale)
 */
export const markListingSold = async (id: number, options?: RequestInit): Promise<Listing> => {

  return customFetch<Listing>(getMarkListingSoldUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkListingSoldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markListingSold>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markListingSold>>, TError,{id: number}, TContext> => {

const mutationKey = ['markListingSold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markListingSold>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markListingSold(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkListingSoldMutationResult = NonNullable<Awaited<ReturnType<typeof markListingSold>>>

    export type MarkListingSoldMutationError = ErrorType<unknown>

    /**
 * @summary Mark a listing as sold (seller confirms sale)
 */
export const useMarkListingSold = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markListingSold>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markListingSold>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkListingSoldMutationOptions(options));
    }

export const getRequestToBuyUrl = (id: number,) => {




  return `/api/listings/${id}/reserve`
}

/**
 * @summary Request to buy a listing and open a conversation with the seller
 */
export const requestToBuy = async (id: number,
    requestToBuyBody: RequestToBuyBody, options?: RequestInit): Promise<PurchaseRequestResult> => {

  return customFetch<PurchaseRequestResult>(getRequestToBuyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestToBuyBody)
  }
);}





export const getRequestToBuyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestToBuy>>, TError,{id: number;data: BodyType<RequestToBuyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestToBuy>>, TError,{id: number;data: BodyType<RequestToBuyBody>}, TContext> => {

const mutationKey = ['requestToBuy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestToBuy>>, {id: number;data: BodyType<RequestToBuyBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  requestToBuy(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestToBuyMutationResult = NonNullable<Awaited<ReturnType<typeof requestToBuy>>>
    export type RequestToBuyMutationBody = BodyType<RequestToBuyBody>
    export type RequestToBuyMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request to buy a listing and open a conversation with the seller
 */
export const useRequestToBuy = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestToBuy>>, TError,{id: number;data: BodyType<RequestToBuyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestToBuy>>,
        TError,
        {id: number;data: BodyType<RequestToBuyBody>},
        TContext
      > => {
      return useMutation(getRequestToBuyMutationOptions(options));
    }

export const getAcceptPurchaseRequestUrl = (id: number,) => {




  return `/api/reservations/${id}/accept`
}

/**
 * @summary Accept a direct purchase request
 */
export const acceptPurchaseRequest = async (id: number, options?: RequestInit): Promise<DirectReservation> => {

  return customFetch<DirectReservation>(getAcceptPurchaseRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptPurchaseRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPurchaseRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptPurchaseRequest>>, TError,{id: number}, TContext> => {

const mutationKey = ['acceptPurchaseRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptPurchaseRequest>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  acceptPurchaseRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptPurchaseRequestMutationResult = NonNullable<Awaited<ReturnType<typeof acceptPurchaseRequest>>>

    export type AcceptPurchaseRequestMutationError = ErrorType<unknown>

    /**
 * @summary Accept a direct purchase request
 */
export const useAcceptPurchaseRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPurchaseRequest>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptPurchaseRequest>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getAcceptPurchaseRequestMutationOptions(options));
    }

export const getCancelPurchaseRequestUrl = (id: number,) => {




  return `/api/reservations/${id}/cancel`
}

/**
 * @summary Cancel a requested or accepted direct transaction
 */
export const cancelPurchaseRequest = async (id: number,
    cancelPurchaseRequestBody?: CancelPurchaseRequestBody, options?: RequestInit): Promise<DirectReservation> => {

  return customFetch<DirectReservation>(getCancelPurchaseRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelPurchaseRequestBody)
  }
);}





export const getCancelPurchaseRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseRequest>>, TError,{id: number;data?: BodyType<CancelPurchaseRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseRequest>>, TError,{id: number;data?: BodyType<CancelPurchaseRequestBody>}, TContext> => {

const mutationKey = ['cancelPurchaseRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPurchaseRequest>>, {id: number;data?: BodyType<CancelPurchaseRequestBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  cancelPurchaseRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPurchaseRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPurchaseRequest>>>
    export type CancelPurchaseRequestMutationBody = BodyType<CancelPurchaseRequestBody> | undefined
    export type CancelPurchaseRequestMutationError = ErrorType<unknown>

    /**
 * @summary Cancel a requested or accepted direct transaction
 */
export const useCancelPurchaseRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPurchaseRequest>>, TError,{id: number;data?: BodyType<CancelPurchaseRequestBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelPurchaseRequest>>,
        TError,
        {id: number;data?: BodyType<CancelPurchaseRequestBody>},
        TContext
      > => {
      return useMutation(getCancelPurchaseRequestMutationOptions(options));
    }

export const getArchiveReservationUrl = (id: number,) => {




  return `/api/reservations/${id}/archive`
}

/**
 * @summary Archive a terminal order for the authenticated buyer or seller
 */
export const archiveReservation = async (id: number, options?: RequestInit): Promise<ArchiveReservation200> => {

  return customFetch<ArchiveReservation200>(getArchiveReservationUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getArchiveReservationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveReservation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveReservation>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveReservation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveReservation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveReservation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveReservationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveReservation>>>

    export type ArchiveReservationMutationError = ErrorType<unknown>

    /**
 * @summary Archive a terminal order for the authenticated buyer or seller
 */
export const useArchiveReservation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveReservation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveReservation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveReservationMutationOptions(options));
    }

export const getArchiveWithdrawnOfferUrl = (id: number,) => {




  return `/api/offers/${id}/archive`
}

/**
 * @summary Archive a withdrawn offer for the authenticated buyer or seller
 */
export const archiveWithdrawnOffer = async (id: number, options?: RequestInit): Promise<ArchiveWithdrawnOffer200> => {

  return customFetch<ArchiveWithdrawnOffer200>(getArchiveWithdrawnOfferUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getArchiveWithdrawnOfferMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWithdrawnOffer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveWithdrawnOffer>>, TError,{id: number}, TContext> => {

const mutationKey = ['archiveWithdrawnOffer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveWithdrawnOffer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  archiveWithdrawnOffer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveWithdrawnOfferMutationResult = NonNullable<Awaited<ReturnType<typeof archiveWithdrawnOffer>>>

    export type ArchiveWithdrawnOfferMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Archive a withdrawn offer for the authenticated buyer or seller
 */
export const useArchiveWithdrawnOffer = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWithdrawnOffer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof archiveWithdrawnOffer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getArchiveWithdrawnOfferMutationOptions(options));
    }

export const getConfirmReceiptUrl = (id: number,) => {




  return `/api/listings/${id}/confirm-receipt`
}

/**
 * @summary Buyer confirms they received the item
 */
export const confirmReceipt = async (id: number, options?: RequestInit): Promise<Listing> => {

  return customFetch<Listing>(getConfirmReceiptUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConfirmReceiptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmReceipt>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmReceipt>>, TError,{id: number}, TContext> => {

const mutationKey = ['confirmReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmReceipt>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  confirmReceipt(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof confirmReceipt>>>

    export type ConfirmReceiptMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Buyer confirms they received the item
 */
export const useConfirmReceipt = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmReceipt>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmReceipt>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getConfirmReceiptMutationOptions(options));
    }

export const getGetUserUrl = (id: number,) => {




  return `/api/users/${id}`
}

/**
 * @summary Get a user profile
 */
export const getUser = async (id: number, options?: RequestInit): Promise<PublicUser> => {

  return customFetch<PublicUser>(getGetUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (id: number,) => {
    return [
    `/api/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a user profile
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUserListingsUrl = (id: number,) => {




  return `/api/users/${id}/listings`
}

/**
 * @summary Get listings by a user
 */
export const getUserListings = async (id: number, options?: RequestInit): Promise<Listing[]> => {

  return customFetch<Listing[]>(getGetUserListingsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserListingsQueryKey = (id: number,) => {
    return [
    `/api/users/${id}/listings`
    ] as const;
    }


export const getGetUserListingsQueryOptions = <TData = Awaited<ReturnType<typeof getUserListings>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserListingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserListings>>> = ({ signal }) => getUserListings(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserListings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserListingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserListings>>>
export type GetUserListingsQueryError = ErrorType<unknown>


/**
 * @summary Get listings by a user
 */

export function useGetUserListings<TData = Awaited<ReturnType<typeof getUserListings>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserListings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserListingsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMessagesUrl = (params: GetMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messages?${stringifiedParams}` : `/api/messages`
}

/**
 * @summary Get messages for a listing
 */
export const getMessages = async (params: GetMessagesParams, options?: RequestInit): Promise<Message[]> => {

  return customFetch<Message[]>(getGetMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagesQueryKey = (params?: GetMessagesParams,) => {
    return [
    `/api/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(params: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesQueryError = ErrorType<unknown>


/**
 * @summary Get messages for a listing
 */

export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendMessageUrl = () => {




  return `/api/messages`
}

/**
 * @summary Send a message
 */
export const sendMessage = async (createMessage: CreateMessage, options?: RequestInit): Promise<Message> => {

  return customFetch<Message>(getSendMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMessage)
  }
);}





export const getSendMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{data: BodyType<CreateMessage>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{data: BodyType<CreateMessage>}, TContext> => {

const mutationKey = ['sendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, {data: BodyType<CreateMessage>}> = (props) => {
          const {data} = props ?? {};

          return  sendMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = BodyType<CreateMessage>
    export type SendMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a message
 */
export const useSendMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{data: BodyType<CreateMessage>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        {data: BodyType<CreateMessage>},
        TContext
      > => {
      return useMutation(getSendMessageMutationOptions(options));
    }

export const getGetWishMessagesUrl = (params: GetWishMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messages/wish?${stringifiedParams}` : `/api/messages/wish`
}

/**
 * @summary Get wish-chat messages between buyer and a specific seller
 */
export const getWishMessages = async (params: GetWishMessagesParams, options?: RequestInit): Promise<WishMessage[]> => {

  return customFetch<WishMessage[]>(getGetWishMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWishMessagesQueryKey = (params?: GetWishMessagesParams,) => {
    return [
    `/api/messages/wish`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWishMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getWishMessages>>, TError = ErrorType<unknown>>(params: GetWishMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWishMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWishMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWishMessages>>> = ({ signal }) => getWishMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWishMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWishMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getWishMessages>>>
export type GetWishMessagesQueryError = ErrorType<unknown>


/**
 * @summary Get wish-chat messages between buyer and a specific seller
 */

export function useGetWishMessages<TData = Awaited<ReturnType<typeof getWishMessages>>, TError = ErrorType<unknown>>(
 params: GetWishMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWishMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWishMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendWishMessageUrl = () => {




  return `/api/messages/wish`
}

/**
 * @summary Send a message in a wish chat (with anti-spam gate)
 */
export const sendWishMessage = async (sendWishMessage: SendWishMessage, options?: RequestInit): Promise<WishMessage> => {

  return customFetch<WishMessage>(getSendWishMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendWishMessage)
  }
);}





export const getSendWishMessageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWishMessage>>, TError,{data: BodyType<SendWishMessage>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendWishMessage>>, TError,{data: BodyType<SendWishMessage>}, TContext> => {

const mutationKey = ['sendWishMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendWishMessage>>, {data: BodyType<SendWishMessage>}> = (props) => {
          const {data} = props ?? {};

          return  sendWishMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendWishMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendWishMessage>>>
    export type SendWishMessageMutationBody = BodyType<SendWishMessage>
    export type SendWishMessageMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Send a message in a wish chat (with anti-spam gate)
 */
export const useSendWishMessage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendWishMessage>>, TError,{data: BodyType<SendWishMessage>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendWishMessage>>,
        TError,
        {data: BodyType<SendWishMessage>},
        TContext
      > => {
      return useMutation(getSendWishMessageMutationOptions(options));
    }

export const getGetConversationsUrl = (params: GetConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messages/conversations?${stringifiedParams}` : `/api/messages/conversations`
}

/**
 * @summary Get all conversations for a user
 */
export const getConversations = async (params: GetConversationsParams, options?: RequestInit): Promise<Conversation[]> => {

  return customFetch<Conversation[]>(getGetConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationsQueryKey = (params?: GetConversationsParams,) => {
    return [
    `/api/messages/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConversationsQueryOptions = <TData = Awaited<ReturnType<typeof getConversations>>, TError = ErrorType<unknown>>(params: GetConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversations>>> = ({ signal }) => getConversations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof getConversations>>>
export type GetConversationsQueryError = ErrorType<unknown>


/**
 * @summary Get all conversations for a user
 */

export function useGetConversations<TData = Awaited<ReturnType<typeof getConversations>>, TError = ErrorType<unknown>>(
 params: GetConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRatingUrl = () => {




  return `/api/ratings`
}

/**
 * @summary Submit a star rating for a seller
 */
export const createRating = async (createRating: CreateRating, options?: RequestInit): Promise<RatingItem> => {

  return customFetch<RatingItem>(getCreateRatingUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRating)
  }
);}





export const getCreateRatingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRating>>, TError,{data: BodyType<CreateRating>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRating>>, TError,{data: BodyType<CreateRating>}, TContext> => {

const mutationKey = ['createRating'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRating>>, {data: BodyType<CreateRating>}> = (props) => {
          const {data} = props ?? {};

          return  createRating(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRatingMutationResult = NonNullable<Awaited<ReturnType<typeof createRating>>>
    export type CreateRatingMutationBody = BodyType<CreateRating>
    export type CreateRatingMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit a star rating for a seller
 */
export const useCreateRating = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRating>>, TError,{data: BodyType<CreateRating>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRating>>,
        TError,
        {data: BodyType<CreateRating>},
        TContext
      > => {
      return useMutation(getCreateRatingMutationOptions(options));
    }

export const getGetUserRatingsUrl = (id: number,) => {




  return `/api/users/${id}/ratings`
}

/**
 * @summary Get all ratings received by a user
 */
export const getUserRatings = async (id: number, options?: RequestInit): Promise<RatingItem[]> => {

  return customFetch<RatingItem[]>(getGetUserRatingsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserRatingsQueryKey = (id: number,) => {
    return [
    `/api/users/${id}/ratings`
    ] as const;
    }


export const getGetUserRatingsQueryOptions = <TData = Awaited<ReturnType<typeof getUserRatings>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRatingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRatings>>> = ({ signal }) => getUserRatings(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRatings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRatingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRatings>>>
export type GetUserRatingsQueryError = ErrorType<unknown>


/**
 * @summary Get all ratings received by a user
 */

export function useGetUserRatings<TData = Awaited<ReturnType<typeof getUserRatings>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRatings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserRatingsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateGuestSessionUrl = () => {




  return `/api/guest-session`
}

/**
 * @summary Create or retrieve a guest user session
 */
export const createGuestSession = async (guestSessionRequest: GuestSessionRequest, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getCreateGuestSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guestSessionRequest)
  }
);}





export const getCreateGuestSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestSession>>, TError,{data: BodyType<GuestSessionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGuestSession>>, TError,{data: BodyType<GuestSessionRequest>}, TContext> => {

const mutationKey = ['createGuestSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGuestSession>>, {data: BodyType<GuestSessionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createGuestSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGuestSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createGuestSession>>>
    export type CreateGuestSessionMutationBody = BodyType<GuestSessionRequest>
    export type CreateGuestSessionMutationError = ErrorType<unknown>

    /**
 * @summary Create or retrieve a guest user session
 */
export const useCreateGuestSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGuestSession>>, TError,{data: BodyType<GuestSessionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGuestSession>>,
        TError,
        {data: BodyType<GuestSessionRequest>},
        TContext
      > => {
      return useMutation(getCreateGuestSessionMutationOptions(options));
    }

export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCloseWishConversationUrl = (id: number,
    sellerId: number,) => {




  return `/api/wanted/${id}/conversation/${sellerId}`
}

/**
 * @summary Buyer rejects a seller's slot — frees the anti-spam counter
 */
export const closeWishConversation = async (id: number,
    sellerId: number, options?: RequestInit): Promise<CloseConversationResponse> => {

  return customFetch<CloseConversationResponse>(getCloseWishConversationUrl(id,sellerId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCloseWishConversationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeWishConversation>>, TError,{id: number;sellerId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeWishConversation>>, TError,{id: number;sellerId: number}, TContext> => {

const mutationKey = ['closeWishConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeWishConversation>>, {id: number;sellerId: number}> = (props) => {
          const {id,sellerId} = props ?? {};

          return  closeWishConversation(id,sellerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseWishConversationMutationResult = NonNullable<Awaited<ReturnType<typeof closeWishConversation>>>

    export type CloseWishConversationMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Buyer rejects a seller's slot — frees the anti-spam counter
 */
export const useCloseWishConversation = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeWishConversation>>, TError,{id: number;sellerId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof closeWishConversation>>,
        TError,
        {id: number;sellerId: number},
        TContext
      > => {
      return useMutation(getCloseWishConversationMutationOptions(options));
    }
